import { installOnWindow } from './session/installOnWindow'
import { SessionStore } from './session/SessionStore'
import { UserSelfService } from './session/UserSelfService'

/**
 * CDN entry — self-executing.
 *
 * One bundle per environment (production, sandbox, testing); each bakes in
 * its API URL and cookie names via rslib's `source.define` from the preset
 * in `rslib.cdn.config.ts`. The host page just loads the right one:
 *
 * ```html
 * <script src="https://alegra-commons-runtime.alegra.com/bootstrap.js"></script>
 * ```
 */
const userSelfService = new UserSelfService()
const sessionStore = new SessionStore(userSelfService)
installOnWindow(sessionStore)

userSelfService.load().then((data) => {
  if (data) sessionStore.applyRawPayload(data)
})
